import { View, StyleSheet, FlatList, TouchableOpacity, Text } from 'react-native';
import React, { useEffect, useState, useLayoutEffect } from 'react';
import { useNavigation, useIsFocused } from '@react-navigation/native';
import TransactionList from '../components/TransactionList';
import { APP_ROLE, EVENT_ACTIONS } from '../constants/Constant';
import { FontAwesome5 } from '@expo/vector-icons';
import useDataStore from '../stores/dataStore';
import DropDownPicker from 'react-native-dropdown-picker';
import { Colors } from '../constants/theme';
import ShowAlert from '../modules/AlertModule';
import Loader from '../components/Loader';
import { handleAlertForError } from '../utils/handleError';
import MixpanelTracker from '../utils/MixpanelTracker';
import { convertToDateTime, sortObjectByDateTime, formatDate } from '../utils/dateUtil';
import { isEmpty } from '../utils/commonUtils';
import { makeApiRequest } from '../utils/apiUtil';
import { MaterialCommunityIcons } from '@expo/vector-icons';
import Popup from "../components/popup";
import DateTimePicker from 'react-native-ui-datepicker';
import Button from '../components/Button';
import html2pdf from 'html2pdf.js';

const FactoryExpense = () => {
    const navigation = useNavigation();
    const [API_CONFIG, userData, setToastMessage, authToken, setAuthToken, refreshToken, setRefreshToken] = useDataStore((state) => ([state.API_CONFIG, state.userData, state.setToastMessage, state.authToken, state.setAuthToken, state.refreshToken, state.setRefreshToken]));
    const [dataKey, setDataKey] = useState(null);
    const [open, setOpen] = useState(false);
    const [value, setValue] = useState(null);
    const [accountList, setAccountList] = useState([]);
    const [accountsData, setAccountsData] = useState(null);
    const [isFocus, setIsFocus] = useState('all');
    const [transactions, setTransactions] = useState(null);
    const [transactionData, setTransactionData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [isStartDatePickerVisible, setStartDatePickerVisibility] = useState(false);
    const [isEndDatePickerVisible, setEndDatePickerVisibility] = useState(false);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    let today = new Date();

    const isFocused = useIsFocused();
    let prevDate = null;

    useLayoutEffect(() => {
        navigation.setOptions({
            title: "Factory Expense"
        });
    });

    useEffect(() => {
        if (isFocused) {
            MixpanelTracker.sendAnalyticsEvent(EVENT_ACTIONS.FACTORY_EXPENSE_CLICKED, userData);
            fetchData("all");
            setIsFocus("all");
            setOpen(false);
        }
    }, [isFocused]);

    useEffect(() => {
        if (transactionData) {
            let filterData = transactionData;
            if (userData.role === APP_ROLE.SUPERVISOR) {
                filterData = Object.values(transactionData).filter(node => node.actionBy === userData.username);
            }
            if (startDate && endDate) {
                updateFilteredTransactions(transactionData, startDate, endDate);
            } else {
                setDataKey(Object.keys(sortObjectByDateTime(filterData)))
                setTransactions(sortObjectByDateTime(filterData));
            }
            setLoading(false);
        }
    }, [transactionData]);

    useEffect(() => {
        if (value) {
            fetchData(value);
        }
    }, [value]);

    const handleDelete = (key) => {
        ShowAlert("Delete", "Are you sure you want to delete this transaction?", "YesNo", () => {
            console.log('OK Pressed');
        }, async () => {
            console.log('Yes Pressed');
            MixpanelTracker.sendAnalyticsEvent(EVENT_ACTIONS.FACTORY_EXPENSE_DELETE_TRANSACTION, userData);
            try {
                await makeApiRequest('delete', `${API_CONFIG.TRANSACTIONS}/accounts/accounts/${key}/${userData.username.toLowerCase()}`, authToken, refreshToken, setAuthToken, setRefreshToken);
                setDataKey(dataKey.filter(item => item !== key))
                setToastMessage("Transaction deleted successfully");
            } catch (err) {
                console.log("Transaction delete err: ", err)
                handleAlertForError(err);
            }
        }, () => {
            console.log('No Pressed');
        }
        );
    }

    const handleAllTransactions = () => {
        setValue(true);
        fetchData("all");
    };

    const fetchData = async (selectAccount) => {
        try {
            setLoading(true);
            const accountResponseData = await makeApiRequest('get', API_CONFIG.ACCOUNTS, authToken, refreshToken, setAuthToken, setRefreshToken);
            const responseData = await makeApiRequest('get', `${API_CONFIG.TRANSACTIONS}/accounts`, authToken, refreshToken, setAuthToken, setRefreshToken);
            if (!isEmpty(accountResponseData)) {
                setAccountsData(accountResponseData);
                const dataArray = Object.entries(accountResponseData).map(([id, label]) => ({ label, value: id }));
                setAccountList(dataArray);
                if (selectAccount === "all") {
                    setTransactionData(sortObjectByDateTime(responseData));
                }
                else if (value !== true) {
                    let filterdata = [];
                    Object.entries(sortObjectByDateTime(responseData)).forEach(([transactionId, transactionData]) => {
                        let accountTypeId = transactionData.accountType;
                        if (value === accountTypeId) {
                            filterdata.push(transactionData);
                        }
                    });
                    setTransactionData(filterdata);
                }
                else {
                    setTransactionData(sortObjectByDateTime(responseData));
                }
            }
            else {
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
            console.error('Error fetching Factory expense:', error);
            handleAlertForError(error);
        }
    };

    const updateFilteredTransactions = (data, startDate, endDate) => {
        let sortedData = {};
        for (let [key, value] of Object.entries(data)) {
            const transactionDate = convertToDateTime(data[key]["date"]);

            if (transactionDate >= convertToDateTime(formatDate(startDate)) && transactionDate <= convertToDateTime(formatDate(endDate))) {
                sortedData[key] = data[key];
            }
        }
        setTransactions(sortedData)
        setDataKey(Object.keys(sortedData))
    }

    const showStartDatePicker = () => {
        setStartDatePickerVisibility(true);
    };

    const showEndDatePicker = () => {
        // Only show the end date picker if the start date is already selected
        if (startDate) {
            setEndDatePickerVisibility(true);
        } else {
            // If start date is not selected, show an alert
            ShowAlert("Try again", "Please select the start date first.", "Ok");
        }
    };

    const hideStartDatePicker = () => {
        setStartDatePickerVisibility(false);
    };

    const hideEndDatePicker = () => {
        setEndDatePickerVisibility(false);
    };

    const handleStartDateConfirm = (date) => {
        setStartDate(date);
        hideStartDatePicker();
        updateFilteredTransactions(transactionData, date, endDate);
    };


    const handleEndDateConfirm = (date) => {
        if (startDate && date < startDate) {
            setEndDatePickerVisibility(false);
            ShowAlert("Wrong Date", "End date cannot be before the start date.", "Ok");
        } else {
            setEndDate(date);
            hideEndDatePicker();
            updateFilteredTransactions(transactionData, startDate, date);
        }
    };

    const generateHTMLContent = () => {
        let total = 0;
        let html = `
        <html>
            <head>
                <title>Factory Expense Report</title>
                <style>
                    body {
                        margin: 30px;
                    }
                    #details {
                        background-color: #fff;
                    }
                    #details_tr {
                        background-color: #fff;
                    }
                    table {
                        width: 100%;
                        border-collapse: collapse;
                    }
                    th, td {
                        border: 1px solid #ddd;
                        padding: 8px;
                        text-align: left;
                    }
                    th {
                        background-color: #dddddd;
                    }

                    h1 {
                        text-align: center;
                    }
                    h3 {
                        text-align: center;
                    }
                    #border {
                        border: 1px solid #000;
                    }
                    table {
                      font-family: arial, sans-serif;
                      border-collapse: collapse;
                      width: 100%;
                    }
                    
                    td, th {
                      border: 1px solid #dddddd;
                      text-align: left;
                      padding: 8px;
                      max-width: 50px;
                    }
                    
                    tr:nth-child(even) {
                      background-color: #f2f2f2;
                    }
                    
                    #endctn p{
                        display: inline-block;
                        margin-right: 10px;
                    }
                    .name-cell {
                            max-width: 50px; /* Adjust this value as needed */
                            word-wrap: break-word; /* Allows long words to break and wrap */
                            white-space: normal; /* Allows text to wrap */
                            overflow-wrap: break-word; /* Ensures long words break */
                    }
                    .date-cell {
                           width: 10px; /* Adjust this value as needed */
                            word-wrap: break-word; /* Allows long words to break and wrap */
                            white-space: normal; /* Allows text to wrap */
                            overflow-wrap: break-word; /* Ensures long words break */
                    }
                    .actionBy-cell {
                            width: 10px; /* Adjust this value as needed */
                            word-wrap: break-word; /* Allows long words to break and wrap */
                            white-space: normal; /* Allows text to wrap */
                            overflow-wrap: break-word; /* Ensures long words break */
                    }
                </style>
            </head>
            <body>
                <h1>Factory Expense Report</h1>
                <div id="border"></div> <br>
                <h3>${formatDate(startDate)} to ${formatDate(endDate)}</h3>
                <br>
                <table>
                    <thead>
                        <tr>
                            <th class="date-cell">Date</th>
                            <th>Expense Type</th>
                            <th>Comment</th>
                            <th>Amount</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
    `;
        let newTransactions = Object.values(transactions);
        for (const transaction of newTransactions) {
            total += parseFloat(transaction?.amount);
            html += `
            <tr>
                <td class="date-cell">${transaction?.date}</td>
                <td class="name-cell">${accountsData[transaction?.accountType]}</td>
                <td class="name-cell">${transaction?.comment}</td>
                <td>${parseFloat(transaction?.amount)}</td>
                <td class="actionBy-cell">${transaction?.actionBy}</td>
            </tr>
        `;
        };

        html += `
        <tr>
                <td><strong>Total Amounts:</strong></td>
                <td></td>
                <td></td>
                <td><strong>₹ ${total}</strong></td>
                <td></td>
            </tr>
                    </tbody>
                </table>
                <br>
            </body>
        </html>
    `;
        return html;
    };

    const handleDownloadPDF = async () => {
        try {
            if (!startDate || !endDate) {
                ShowAlert("Try again", "Please select the start and end date.", "Ok");
                return;
            }
            MixpanelTracker.sendAnalyticsEvent(EVENT_ACTIONS.DOWNLOAD_PDF_BUTTON_CLICKED, userData);
            const htmlContent = generateHTMLContent();
            let formatedDate = formatDate(today);
            const fileName = `${value ? accountsData[value] : 'All'}_factory_expense_${formatedDate}.pdf`;

            const element = document.createElement("div");
            element.innerHTML = htmlContent;

            html2pdf(element, {
                filename: fileName,
            });
        } catch (error) {
            console.error('Error downloading PDF:', error);
        }
    };

    return (
        <View style={styles.container}>
            <View style={styles.dropdownContainer}>
                <DropDownPicker
                    placeholder='Select Account'
                    style={[styles.dropdownPicker, isFocus === "picker" && { borderColor: Colors.primary, borderWidth: 2 }]}
                    dropDownContainerStyle={[styles.dropdownPicker, isFocus && { borderColor: Colors.primary, borderWidth: 2 }]}
                    open={open}
                    value={value}
                    items={accountList}
                    setOpen={(val) => {
                        setOpen(val);
                    }}
                    setValue={setValue}
                    setItems={accountList}
                    onOpen={() => setIsFocus("picker")}
                    onClose={() => setIsFocus("picker")} />
            </View>
            <TouchableOpacity style={styles.allButton} onPress={() => {
                MixpanelTracker.sendAnalyticsEvent(EVENT_ACTIONS.FACTORY_EXPENSE_TRANSACTION_ALL, userData);
                setIsFocus("all");
                handleAllTransactions();
                setOpen(false);
            }}>
                <View style={styles.buttonView}>
                    <Text style={[styles.allButtonText, isFocus === "all" && styles.focusedButton]}>All</Text>
                </View>
            </TouchableOpacity>
            <View style={styles.datePickerContainer}>
                <View style={styles.startDateContainer}>
                    <TouchableOpacity onPress={showStartDatePicker}>
                        <View style={styles.startDateContainerView}>
                            <FontAwesome5
                                name="calendar"
                                size={16}
                                color={Colors.primary}
                            />
                            <Text style={styles.startDateText}> {startDate ? startDate.toDateString() : "Select start date"}</Text>
                            <FontAwesome5
                                name="caret-down"
                                size={16}
                                color={Colors.primary}
                            />
                            <Popup visible={isStartDatePickerVisible} onClose={() => setStartDatePickerVisibility(false)}>
                                <DateTimePicker
                                    mode="single"
                                    date={startDate || new Date()}
                                    maxDate={today}
                                    onChange={(param) => {
                                        handleStartDateConfirm(new Date(param.date));
                                        setStartDatePickerVisibility(false)
                                    }}
                                    headerButtonStyle={{ color: 'green' }}
                                />
                            </Popup>
                        </View>
                    </TouchableOpacity>
                </View>
                <View style={styles.endDateContainer}>
                    <TouchableOpacity onPress={showEndDatePicker}>
                        <View style={styles.endDateContainerView}>
                            <FontAwesome5
                                name="calendar"
                                size={16}
                                color={Colors.primary}
                            />
                            <Text style={styles.endDateText}> {endDate ? endDate.toDateString() : "Select end date"}</Text>
                            <FontAwesome5
                                name="caret-down"
                                size={16}
                                color={Colors.primary}
                            />
                            <Popup visible={isEndDatePickerVisible} onClose={() => setEndDatePickerVisibility(false)}>
                                <DateTimePicker
                                    mode="single"
                                    date={endDate || new Date()}
                                    maxDate={today}
                                    onChange={(param) => {
                                        handleEndDateConfirm(new Date(param.date));
                                        setEndDatePickerVisibility(false)
                                    }}
                                    headerButtonStyle={{ color: 'green' }}
                                />
                            </Popup>
                        </View>
                    </TouchableOpacity>
                </View>
                <Button
                    onPress={handleDownloadPDF}
                    btnLabel="Download PDF"
                    buttonStyle={styles.button}
                    textStyle={styles.buttonText}
                />
            </View>
            {loading ? (
                <View style={styles.loaderContainer}>
                    <Loader size="large" />
                </View>
            ) :
                dataKey?.length > 0 && transactions && accountsData !== null ?
                    <FlatList
                        data={dataKey}
                        style={styles.flatListStyle}
                        onScrollBeginDrag={() => { if (open) setOpen(false) }}
                        renderItem={({ item: key }) => {
                            let jsx = <>
                                {prevDate !== transactions[key]?.date && <View style={styles.dateView}><Text style={styles.textDate}>{transactions[key]?.date}</Text></View>}
                                <View style={styles.rowContainer}>
                                    <View style={{
                                        width: '100%'
                                    }}>
                                        <TransactionList
                                            key={key}
                                            comment={accountsData[transactions[key].accountType]} // Passing account type for instead of comment
                                            commentFactoryExpense={transactions[key].comment}
                                            date={transactions[key].date}
                                            time={transactions[key].time}
                                            amount={transactions[key].amount}
                                            user={transactions[key].actionBy}
                                            id={transactions[key]?.id}
                                            transactionId={transactions[key]?.id}
                                            accountType={transactions[key].accountType}
                                            allowedRole={[APP_ROLE.OWNER, APP_ROLE.SUPERVISOR]}
                                        />
                                    </View>
                                    {userData.username === transactions[key]?.actionBy && <TouchableOpacity style={styles.trigger} onPress={() => handleDelete(transactions[key]?.id)}>
                                        <MaterialCommunityIcons name="delete" size={28} color="#000" />
                                    </TouchableOpacity>}
                                </View>
                            </>
                            prevDate = transactions[key].date;
                            return (jsx);
                        }}
                        keyExtractor={(item) => item}
                    /> : <View style={styles.centeredView}>
                        <Text style={styles.noTransaction}>No Transactions Found</Text>
                    </View>}
        </View>
    );
}

const styles = StyleSheet.create({
    buttonText: {
        color: '#fff',
        fontSize: 14,
        fontWeight: 'bold',
    },
    button: {
        flexDirection: 'row',
        backgroundColor: Colors.secondary,
        borderRadius: 5,
        fontSize: 14,
        width: 'unset',
        marginHorizontal: 10,
        height: 50,
        top: 14
    },
    rowContainer: {
        flexDirection: 'row',
        // justifyContent: 'space-between',
        alignItems: 'center',
        width: '90%',
        marginVertical: 5
    },
    container: {
        flex: 1,
        alignItems: 'center'
    },
    datePickerContainer: {
        flexDirection: 'row',
        top: 40
    },
    startDateContainer: {
        flexDirection: 'row',
        alignItems: 'center',
        height: 55,
        borderColor: '#636363',
        borderRadius: 6,
        paddingHorizontal: 8,
        margin: 12,
        padding: 6,
        width: '45%',
        backgroundColor: "white"
    },
    startDateContainerView: {
        flexDirection: 'row',
    },
    startDateText: {
        marginLeft: 5,
        marginRight: 5
    },
    endDateContainer: {
        flexDirection: 'row',
        alignItems: 'center',
        height: 55,
        borderColor: '#636363',
        borderRadius: 6,
        marginTop: 12,
        paddingLeft: 6,
        width: '45%',
        backgroundColor: "white"
    },
    endDateContainerView: {
        flexDirection: 'row',
        padding: 5,
    },
    endDateText: {
        marginLeft: 5,
        marginRight: 5
    },
    loaderContainer: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
    },
    dropdownContainer: {
        width: '90%',
        paddingVertical: 10,
        flexDirection: 'row',
        zIndex: 100
    },
    dropdownPicker: {
        width: '60%',
        position: 'absolute',
    },
    buttonView: {
        border: 1,
    },
    allButton: {
        width: '35%',
        position: 'absolute',
        left: '65%',
        paddingVertical: 9,
        paddingRight: 10,
    },
    focusedButton: {
        borderColor: Colors.primary,
        borderWidth: 2
    },
    allButtonText: {
        fontSize: 14,
        padding: 14,
        borderWidth: 1,
        borderColor: 'black',
        borderRadius: 10,
        backgroundColor: 'white',
    },
    dateView: {
        width: '100%',
        justifyContent: 'center',
        alignItems: 'center',
    },
    textDate: {
        backgroundColor: 'white',
        textAlign: 'center',
        width: "30%",
        borderRadius: 5,
    },
    flatListStyle: {
        marginTop: '45px',
        width: '100%',
        height: '100%',
    },
    centeredView: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
    },
    noTransaction: {
        textAlign: 'center',
    },
});

export default FactoryExpense